// xpConfig.js — Config XP/niveaux partagée (espace membre + HUD in-game).
// DOIT rester alignée sur le serveur vg_progression.lua (source de vérité unique) :
//   xp_for_level(L) = floor(60 * (L-1)^2.4) ; niveau 1 = 0 XP ; max = 120. Courbe LENTE (cf. serveur).

export const MAX_LEVEL = 120;
export function xpForLevel(L) { return Math.floor(60 * Math.pow(Math.max(0, L - 1), 2.4)); }

export function levelForXp(xp) {
  let lvl = 1;
  while (lvl < MAX_LEVEL && xp >= xpForLevel(lvl + 1)) lvl += 1;
  return lvl;
}

// Statut par niveau (identique à status_for_level côté serveur, recalibré pour le max 120).
export function statusForLevel(l) {
  if (l >= 120) return 'Légende Ultime';
  if (l >= 100) return 'Mythe';
  if (l >= 80) return 'Légende';
  if (l >= 60) return 'Maître';
  if (l >= 45) return 'Diamant';
  if (l >= 30) return 'Platine';
  if (l >= 20) return 'Or';
  if (l >= 12) return 'Argent';
  if (l >= 5) return 'Bronze';
  return 'Recrue';
}

// Progression + bornes du niveau courant (jauge). Utilisée quand on n'a que l'XP brute.
export function progressFromXp(xp) {
  const level = levelForXp(xp);
  const cur = xpForLevel(level);   // début du niveau courant (0 au niveau 1)
  const next = xpForLevel(level + 1);
  const span = Math.max(1, next - cur);
  return {
    xp, level, status: statusForLevel(level),
    xpForCurrent: cur, xpForNext: next, span,
    into: xp - cur,
    pct: Math.max(0, Math.min(100, Math.round(((xp - cur) / span) * 100))),
  };
}

// % de progression dans le niveau courant à partir des bornes serveur (xpForCurrent/xpForNext).
export function pctFromBounds(xp, cur, next) {
  const span = Math.max(1, (next || 0) - (cur || 0));
  return Math.max(0, Math.min(100, Math.round((((xp || 0) - (cur || 0)) / span) * 100)));
}

// Feuille de route des déblocages (miroir de status_for_level + unlocks_for côté serveur).
export const ROADMAP = [
  { level: 2, status: 'Recrue', reward: 'Badge Bronze sur ton profil' },
  { level: 5, status: 'Bronze', reward: 'Statut Bronze + skin de jeu' },
  { level: 8, status: 'Bronze', reward: 'Emplacement de caisse bonus (gameplay)' },
  { level: 12, status: 'Argent', reward: 'Statut Argent + titre' },
  { level: 15, status: 'Argent', reward: 'Arme spéciale (gameplay)' },
  { level: 20, status: 'Or', reward: 'Statut Or + titre doré' },
  { level: 22, status: 'Or', reward: 'Capacité spéciale (gameplay)' },
  { level: 30, status: 'Platine', reward: 'Statut Platine + skin légendaire' },
  { level: 45, status: 'Diamant', reward: 'Statut Diamant' },
  { level: 60, status: 'Maître', reward: 'Statut Maître' },
  { level: 80, status: 'Légende', reward: 'Statut Légende' },
  { level: 100, status: 'Mythe', reward: 'Statut Mythe' },
  { level: 120, status: 'Légende Ultime', reward: 'Rang maximal — Légende Ultime' },
];

// Paliers de mentions selon l'XP gagnée d'un coup (feedback in-game).
export const PRAISE = [
  { min: 40, label: 'TYRAN !', color: '#ef4444' },
  { min: 25, label: 'Commando', color: '#f59e0b' },
  { min: 12, label: 'Belle exécution', color: '#22c55e' },
  { min: 5, label: 'Touché', color: '#38bdf8' },
  { min: 1, label: '+XP', color: '#a78bfa' },
];

export function praiseFor(amount) {
  return (PRAISE.find((p) => amount >= p.min) || PRAISE[PRAISE.length - 1]).label;
}
